import {
    Box,
    Button,
    Group,
    LoadingOverlay,
    Select,
    TextInput,
    Textarea,
  } from "@mantine/core";
  import { isNotEmpty, useForm } from "@mantine/form";
  import { useDisclosure } from "@mantine/hooks";
  import { modals } from "@mantine/modals";
  import { IconCheck } from "@tabler/icons-react";
  import { tblBannerVoucher } from "../../../model/Voucher";
  import { createBannerVoucher } from "../../../api/ApiVoucher";
  import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { modifyTradeInOrder } from "../../../api/ApiTradeIn";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblTradeInOrder } from "../../../model/TblTradeIn";
import { useEffect } from "react";

  const Voucher = () => {
    const entity = {
        vourcher:null,
        message:null,
    };
  
    const handleCreateProductAdsCategory = async (
    ) => {
      open();
      if (form.values.vourcher) {
        await callApiGetData();
      }
      close();
      modals.closeAll();
    };
  
    const [visible, { toggle, close, open }] = useDisclosure(false);
  
    const form = useForm<tblBannerVoucher>({
      initialValues: {
        ...entity,
      },
      validate: {
        message: isNotEmpty('Vui lòng nhập voucher'),
      },
    });
  
    const callApiGetData = async () => {
        open();
        const repository = new Repository(process.env.REACT_APP_BASE_VOUCHER_HACOM_URL);
        let urlCreate = `${API_ROUTE.PROMO_TION_HACOM}?vourcher=${form.values.vourcher}`;
        try {
          const response = await repository.post<MessageResponse<tblBannerVoucher>>(urlCreate);
          if (!isNullOrUndefined(response) && !isNullOrUndefined(response?.data)) {
            const dataApi = response?.data;
            if (dataApi != null && !isNullOrUndefined(dataApi)) {
              form.setValues(dataApi);
            } else {
              NotificationExtension.Fails("Dữ liệu không tồn tại");
            }
          } else {
            NotificationExtension.Fails("Dữ liệu không tồn tại");
          }
        } catch (error) {
          NotificationExtension.Fails("Đã xảy ra lỗi khi gọi API");
        } finally {
          close();
          modals.closeAll();
        }
      };
      
      // useEffect(() => {
      //   callApiGetData();
      // }, [/* các giá trị phụ thuộc nếu cần */]);




    return (
      <>
        <Box
          className="flex-none"
          component="form"
          miw={400}
          maw={400}
          mx="auto"
     
        >
          <LoadingOverlay
            visible={visible}
            zIndex={1000}
            overlayProps={{ radius: "sm", blur: 2 }}
          />
          <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
            <TextInput
              label={"Mã Voucher"}
              placeholder={"Nhập Voucher"}
              withAsterisk
              mt="md"
              type="text"
              {...form.getInputProps("vourcher")}
            />
           </Group>
  
          <Group justify="flex-end" mt="lg">
            <Button
              onClick={() => handleCreateProductAdsCategory()}
              color="#3598dc"
              loading={visible}
              leftSection={!visible ? <IconCheck size={18} /> : undefined}
            >
              Kích Hoạt
            </Button>
          </Group>
        </Box>
      </>
    );
  };
  
  export default Voucher;
  